import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from 'prop-types';
import React from 'react';
import compose from '../../hoc/compose';
import { dataHooks } from '../contextMenu/constants';
import displayNames from '../displayNames';

var ContextMenuAction = /*#__PURE__*/function (_React$Component) {
  _inherits(ContextMenuAction, _React$Component);

  var _super = _createSuper(ContextMenuAction);

  function ContextMenuAction() {
    _classCallCheck(this, ContextMenuAction);

    return _super.apply(this, arguments);
  }

  _createClass(ContextMenuAction, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: this.props.getClassName('context-menu-action ') + (this.props.active ? ' active ' : '') + (this.props.disabled ? ' disabled' : ''),
        "data-aid": this.props.automationId,
        "data-hook": this.props.dataHook,
        "data-menu-action": "".concat(dataHooks.menuAction, "-").concat(this.props.dataHook),
        "data-disabled": this.props.disabled ? 'true' : 'false',
        onClick: this.props.disabled ? null : this.props.onClick,
        onMouseEnter: this.props.disabled ? null : this.props.onMouseEnter,
        onMouseLeave: this.props.disabled ? null : this.props.onMouseLeave
      }, this.props.children);
    }
  }]);

  return ContextMenuAction;
}(React.Component);

ContextMenuAction.displayName = displayNames.CONTEXT_MENU_ACTION;
ContextMenuAction.propTypes = {
  onClick: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  active: PropTypes.bool,
  disabled: PropTypes.bool
};
export default compose(ContextMenuAction);